//
//  customers.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';
import CustomersData from '@/constants/data/customers';

@Component
export default class Customers extends Vue {

    @Prop(String) private readonly context!: string;

    private get customersList(): string[] {

        return CustomersData.getList(this.context).map((customer: string) => {

            return this.$i18n.t(`strings.${this.context}.customers.${customer}`).toString();

        });

    }


    private onCustomerHover(index: number): void  {

        this.$store.commit('dataModule/setBackgroundUrl', CustomersData.getList(this.context)[index]);

    }

}
